import React, { useState }              from "react";
import MedicalCertificateTable          from './MedicalCertificateTable';
import MedicalCertificateShareModal     from './MedicalCertificateShareModal';

function MedicalCertificateDetails({emc, getDaysDiff}) {
  const [showShareModal, setShareModal] = useState(false);

  return (
    <div className="p-2">
      {emc?.status !== 'paid' && <div className="mb-3 font-weight-bold"><i>**Pending Payment**</i></div>}
      <MedicalCertificateTable mc={emc} getDaysDiff={getDaysDiff}/>
      {emc?.status === 'paid'  &&
        <div className="w-100 d-flex justify-content-end">
          <button className="btn btn-danger save-mc-btn" onClick={() => {setShareModal(true)}}>Share e-MC</button>
        </div>
      }
      <MedicalCertificateShareModal mc={emc} showShareModal={showShareModal} setShareModal={setShareModal}/>
    </div>
  );
}

export default MedicalCertificateDetails;
